export const environment = {
  production: true,
  environment_name: 'canalwalk',
  environment_title: 'Canal Walk',
  environment_url: 'https://canalwalk.co.za/',
  environment: 'prod',
  api_base_url: 'https://api.hyprop.co.za/',
  api_auth_url: 'https://auth-api.hyprop.co.za/',
  cdn_url: 'https://cdn.hyprop.co.za/',
  mall_id: 'a0e878f8-8443-423c-a4fc-17c82b97fb9b',
  addressLat: -33.89299492774584,
  addressLng: 18.509535614998082,
  cinemaID: 6,
  recaptcha_key: '6LeJuCcbAAAAAMiZ_rBgq7NTiEQVrjNZ1J6f1zAL',
  social_google_key:
    '150343683952-08m97b42cr2fc2v4j1qnckfmq1np0hn9.apps.googleusercontent.com',
  social_facebook_key: '253233436432992',
  sso_url: 'https://sso.hyprop.co.za',
  google_verification: 'hVQzGKOCzY8OPnv2NpiFvbNF8Wfw3eTSPAzeN9h_lj0',
  street_address:
    'Canal Walk Shopping Centre, Century Boulevard, Century City, Cape Town',
  address_locality: 'Cape Town',
  postal_code: '7441',
  address_country: 'ZA',
  contact_form_uuid: 'aorhrimu',
  google_api_key: 'AIzaSyCEvUD2-2IuJdnY4mCmiPHjrdjDsskcTG8',
  form4_link:
    'https://cdn.hyprop.co.za/document/2024/2/19/43759a68-96cc-4b57-a9e0-cefd5da69e85/fb5146cf-f553-4490-82f7-3dcf0ed2749b.pdf',
  tiktok_url: 'https://www.tiktok.com/@canalwalk',
  sitemap_image:
    'https://cdn.hyprop.co.za/image/2026/7/20/eb9466d1-3b0c-421e-b8e5-1dbded2925c6/c6b37bb4-9d9b-41dd-bcfe-c74a180d4616.jpg',
  error_image:
    'https://cdn.hyprop.co.za/image/2026/7/20/497da1ca-642c-4ec2-87dc-75c7d0b3edd2/1398f4bb-2ff1-4545-8ae8-2d32d3d666af.jpg',
};
